import { css, styled } from '@mui/material'

export const Container = styled('div')`
  width: 100%;
  height: 100%;
  min-height: ${({ theme }) => theme.spacing(2.5)};
  padding: ${({ theme }) => theme.spacing(2)};
  border: ${({ theme }) => css`
    ${theme.spacing(0.125)} solid ${theme.palette.common.divider}
  `};
  border-radius: ${({ theme }) => theme.spacing(3)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  position: relative;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.palette.background.base};
`

export const BodyContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`

export const BadgeContainer = styled('div')`
  position: absolute;
  top: -${({ theme }) => theme.spacing(1.5)};
  right: ${({ theme }) => theme.spacing(3)};
`
